<!-- 下载组件
   <download v-if="result.importFail>0" down-message="是否下载失败条目" :data="{url:result.importFailFile,fileName:'导入失败文件'}">下载失败条目</download>
 -->
<template>
    <div @click="doDownloadFile()" class="ib cp primary">
      <slot></slot>
    </div>
</template>

<script>
  import '../../../static/plugin/jquery.fileDownload'
  export default {
    props:{
      url:{
        type:String,
        default:baseURL+"/api/mgr/upload/download"
      },
      downMessage:{
        type:String,
        default: "是否下载文件?"
      },
      data:{
        type:Object,
        default:{},
        required:true
      },
    },
    name: 'download',
    data () {
      return {}
    },
    mixins: [tableBase],
    methods: {
      doDownloadFile(){
        this.showConfirm(this.downMessage,()=>{
          let that = this;
          let data = this.data;
          data._header = localStorage.getItem("qc_token");
          $.fileDownload(this.url, {
            httpMethod : 'POST',
            data : data,
            prepareCallback : function(url) {

            },
            successCallback : function(url) {
              //that.message("下载成功");
            },
            failCallback : function(html, url) {
              that.messageError(JSON.parse($(html).text()).desc);
            }
          });
        },"info")
      }
    },
    mounted () {
    }
  }
</script>

<style lang="less" scoped>

</style>
